import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=4955b8b3&scoped=true&"
import script from "./Buttons.vue?vue&type=script&lang=js&"
export * from "./Buttons.vue?vue&type=script&lang=js&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=4955b8b3&prod&lang=scss&scoped=true&"
import style1 from "./Buttons.vue?vue&type=style&index=1&id=4955b8b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955b8b3",
  null
  
)

export default component.exports